import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActionPayload {
  auditTrack?: boolean;
}

const initialState: ActionPayload = {
  auditTrack: true,
};

const modbusclientConfigSlice = createSlice({
  name: "toaster",
  initialState,
  reducers: {
    setModbusConfigAuditTrack: (state, action: PayloadAction<boolean>) => {
      state.auditTrack = action.payload;
    },
  },
});

export const { setModbusConfigAuditTrack } = modbusclientConfigSlice.actions;
export default modbusclientConfigSlice.reducer;
